import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CiLocationOn } from "react-icons/ci";
import { UserContext } from "../../context/UserContext";

import "./nursingSerivec.css";
import ComingSoonModel from "../Modal/ComingSoonModel";

// Import Images
import nursingservice1 from "../../assets/nrs.png";
import nursingservice2 from "../../assets/hsp.png";
import nursingservice3 from "../../assets/pth.png";
import nursingservice4 from "../../assets/med.png";
import nursingservice5 from "../../assets/medcl.png";

import nursingserviceicon1 from "../../assets/nurs.png";
import nursingserviceicon2 from "../../assets/hospital.png";
import nursingserviceicon3 from "../../assets/lab.png";
import nursingserviceicon4 from "../../assets/medicine.png";
import nursingserviceicon5 from "../../assets/medical.png";

// Static Nursing Services Data
const nursingServices = [
  {
    id: 1,
    image: nursingservice1,
    inner_image: nursingserviceicon1,
    service_name: "Nursing Services",
    location: "90 Listings",
    link: "nursingSubcategories",
  },
  {
    id: 2,
    image: nursingservice2,
    inner_image: nursingserviceicon2,
    service_name: "Hospitals",
    location: "133 Listings",
    link: "nursingSubcategories",

  },
  {
    id: 3,
    image: nursingservice3,
    inner_image: nursingserviceicon3,
    service_name: "Path Lab Test",
    location: "24 Listings",
    link: "nursingSubcategories",
  },
  {
    id: 4,
    image: nursingservice4,
    inner_image: nursingserviceicon4,
    service_name: "Medicine Delivery",
    location: "55 Listings",
    link: "nursingSubcategories",
  },
  {
    id: 5,
    image: nursingservice5,
    inner_image: nursingserviceicon5,
    service_name: "Medical Transportation",
    location: "83 Listings",
    link: "nursingSubcategories",
  },
];

const NursingService = ({ toptext, middletext, lasttext, services = [] }) => {
  const { setServiceid, setServicename } = useContext(UserContext);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1190,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleServiceClick = (id, name) => {
    setServiceid(id);
    setServicename(name);
  };

  return (
    <div className="container nursingSerivec">
      <div className="text-center">
        <span className="primary-color">{toptext}</span>
        <h2>{middletext}</h2>
        <p>{lasttext}</p>
      </div>

      <div className="slider-container mt-5">
        <Slider {...settings}>
          {services.map((service) => {
            const path = service.web_screen_name
              ? `/${service.web_screen_name}`
              : `/innerservices/${service.id}`;

            return (
              <Link
                key={service.id}
                to={path}
                className="service-card"
                onClick={() => {
                  setServiceid(service.id);
                  setServicename(service.service_name);
                }}
              >
                <img src={service.web_icon} className="inner-img" alt="Inner Icon" />
                <img src={service.background_image} className="service-img" alt={service.service_name} />
                <h5>{service.service_name}</h5>
              </Link>
            );
          })}

        </Slider>
      </div>
    </div>
  );
};

export default NursingService;
